import { Mqtt_Topics_sessionsChanges, Mqtt_Topics_reportChanges, Mqtt_Topics_telepathologyChanges, Mqtt_Topics_notesChanges } from "../Optiscan.Models/Api/Api.js";
import { ofArray } from "../fable_modules/fable-library.3.7.12/List.js";
import { Msg } from "./PatientSearchTypes.js";

export function subscribe(uid) {
    return [ofArray([Mqtt_Topics_notesChanges(uid), Mqtt_Topics_telepathologyChanges, Mqtt_Topics_reportChanges(uid), Mqtt_Topics_sessionsChanges(uid)]), (arg0) => (new Msg(2, arg0))];
}

